module.exports = __webpack_public_path__ + "img/top6.9d29708b.png";